const FRAME =
  'bg-elevated border-default flex h-full min-h-0 max-w-full shrink-0 flex-col border-r';
const OVERLAY = 'absolute inset-y-0 left-0 z-30 shadow-lg';

/**
 * The panel takes a column of its own only where the page can spare it: from `lg` alone, from `xl`
 * beside the assistant, whatever the assistant's size. Elsewhere it overlays the page's left edge,
 * so it gives way before the assistant does.
 */
export function planPanelHostClass(args: {
  expanded: boolean;
  assistantOpen: boolean;
}): string {
  if (args.expanded) return `${FRAME} ${OVERLAY} w-1/2 min-w-[min(520px,100%)]`;
  const collapsed = `${FRAME} ${OVERLAY} w-[340px]`;
  return args.assistantOpen
    ? `${collapsed} xl:static xl:shadow-none`
    : `${collapsed} lg:static lg:shadow-none`;
}

/**
 * Holds the collapsed panel's column while the expanded panel overlays the page, at exactly the
 * widths where the collapsed panel is static, so expanding does not re-lay out the page behind it.
 */
export function planPanelPlaceholderClass(args: { assistantOpen: boolean }): string {
  return args.assistantOpen
    ? 'hidden w-[340px] shrink-0 xl:block'
    : 'hidden w-[340px] shrink-0 lg:block';
}
